export default __webpack_public_path__ + "static/media/icon_story_2.8332c612.svg";